import React from 'react';

export type ExpenseColumnId =
  | 'concepto'
  | 'categoria'
  | 'fecha'
  | 'base'
  | 'iva'
  | 'total';

export interface ExpenseUiColumn {
  id: ExpenseColumnId;
  label: string;
  enabled: boolean;
  alignRight?: boolean;
  minWidth?: number;
  render: (g: any) => React.ReactNode;
  exportValue: (g: any) => string | number;
}

export const DEFAULT_EXPENSE_COLUMNS: ExpenseUiColumn[] = [
  {
    id: 'concepto',
    label: 'Concepto',
    enabled: true,
    render: (g) => g.concepto,
    exportValue: (g) => g.concepto,
  },
  {
    id: 'categoria',
    label: 'Categoría',
    enabled: true,
    render: (g) => g.categoria_gasto || '-',
    exportValue: (g) => g.categoria_gasto || '',
  },
  {
    id: 'fecha',
    label: 'Fecha',
    enabled: true,
    render: (g) => g.fecha_inicio,
    exportValue: (g) => g.fecha_inicio,
  },
  {
    id: 'base',
    label: 'Base',
    enabled: true,
    alignRight: true,
    render: (g) =>
      Number(g.base_imponible ?? g.recibos?.[0]?.base ?? 0).toFixed(2) + ' €',
    exportValue: (g) =>
      Number(g.base_imponible ?? g.recibos?.[0]?.base ?? 0).toFixed(2),
  },
  {
    id: 'iva',
    label: 'IVA',
    enabled: true,
    alignRight: true,
    render: (g) => Number(g.iva_porcentaje ?? 0).toFixed(2) + '%',
    exportValue: (g) => Number(g.iva_porcentaje ?? 0).toFixed(2),
  },
  {
    id: 'total',
    label: 'Total',
    enabled: true,
    alignRight: true,
    render: (g) => Number(g.total_mes ?? 0).toFixed(2) + ' €',
    exportValue: (g) => Number(g.total_mes ?? 0).toFixed(2),
  },
];
